import { Component } from '@theme/component';

/**
 * @typedef {object} Refs
 * @property {import('./slideshow').Slideshow} [slideshow]
 *
 * @extends {Component<Refs>}
 */
export class ClientExperiences extends Component {
  requiredRefs = ['slideshow'];

  /**
   * @param {Event} [event]
   */
  next(event) {
    event?.preventDefault();

    const slideshow = this.refs.slideshow;
    if (!slideshow) return;

    slideshow.select(slideshow.current + 1, undefined, { animate: true });
  }

  /**
   * @param {Event} [event]
   */
  previous(event) {
    event?.preventDefault();

    const slideshow = this.refs.slideshow;
    if (!slideshow) return;

    slideshow.select(slideshow.current - 1, undefined, { animate: true });
  }
}

if (!customElements.get('client-experiences')) {
  customElements.define('client-experiences', ClientExperiences);
}
